export default __webpack_public_path__ + "static/media/medical_20.28b55f68.jpg";